import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/EmailTemplate/GetGroupWithPaging",
    method: "get",
    params
  });
}
export function addTemplate(data) {
  return request({
    url: "/EmailTemplate/Add",
    method: "post",
    data
  });
}
export function updateTemplate(data) {
  return request({
    url: "/EmailTemplate/Update",
    method: "post",
    data
  });
}
export function deleteTemplate(data) {
  return request({
    url: "/EmailTemplate/Delete",
    method: "delete",
    data
  });
}
